<template>
    <section class="product-section product-mainfeatures">
        <h2 class="product-section-title">Main Features</h2>
        <ul class="product-mainfeatures-desc">
            <li
                v-for="(item, index) in mainFeatures.desc" :key="index"
            >{{item}}</li>
        </ul>
        <div class="icons-wrap mb-4">
            <b-img
                class="product-mainfeatures-icon"
                :src="src"
                v-for="(src, index) in mainFeatures.featureIcons" :key="index" 
                fluid 
            />
        </div>
        <h2 class="product-section-title">Material</h2>
        <ul class="product-mainfeatures-desc">
            <li
                v-for="(item, index) in mainFeatures.material" :key="index"
            >{{item}}</li>
        </ul>
    </section>
</template>

<script>
export default {
    props: ['mainFeatures'],
}
</script>

<style lang="scss">
    .product-mainfeatures{
        padding: 15px;
        background-color: $color-light;

        &-desc{
            margin-bottom: 35px;
            padding-left: 20px;
            li{
                list-style-position: outside;
                list-style-type: disc;}
        }

        &-icon{
            margin: 0 5px;
            width: 45px;
        }
    }
</style>